<template>
  <div
    class="level"
    @keypress.enter="handleLogin"
  >
    <div class="level-item">
      <b-columns is-multiline>
        <b-column class="is-full">
          <h1 class="is-size-3 has-text-centered has-text-weight-semibold has-text-white">CBRN TOOLBOX</h1>
        </b-column>
        <b-column class="box is-full is-radiusless">
          <div id="heading-container">
            <h2 class="is-size-4 has-text-centered">Log in</h2>

          </div>
          <div class="is-padded-small">
            <b-field>
              <b-input
                placeholder="Username"
                name="username"
                v-model="loginForm.username"
              />
            </b-field>
            <b-field>
              <b-input
                placeholder="Password"
                name="password"
                type="password"
                v-model="loginForm.password"
              />
            </b-field>
          </div>
          <div
            id="button-row"
            class="is-padded-small"
          >
            <button
              @click="handleLogin"
              class="button is-primary"
            >
              Log in
            </button>
          </div>
          <div class="is-padded-small has-text-danger">
            {{ this.errorMessage }}
          </div>
        </b-column>
      </b-columns>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'

export default {
  name: 'Login',
  data () {
    return {
      logo,
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      redirect: undefined,
      errorMessage: null,
    }
  },
  methods: {
    async handleLogin () {
      try {
        this.loading = true
        await this.$store.dispatch('login', this.loginForm)
        this.$router.push({ path: this.redirect || '/' })
      } catch (error) {
        this.errorMessage = 'Error logging in'
        this.loading = false
      }
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
#heading-container {
  height: 4rem;
  position: relative;
}
#toxi-logo {
  position: absolute;
  display: block;
  top: 0px;
  right: 0px;
  height: 100%;
  padding: 5px;
  width: auto;
}

#button-row {
  margin-top: 2em;

  button {
    width: 100%;
  }
}
</style>
